import AuthCardContainer from './AuthCardContent'
import OTPVerify from './Components/OTPVerify';

const OTPVerification = () => {
  return (
    <AuthCardContainer>
      <OTPVerify />
    </AuthCardContainer>
  );
}

export default OTPVerification